<template>
  <el-dialog :title="form.id?'编辑':'新建'" :visible.sync="formVisible" width="1200px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <!-- 【项目落地】专属：分类类别恒为 10，不给选，也不显示选择器。
           共用的【营销分类配置】里才有 9 个板块的类别切换。 -->
      <el-card class="box-card mt10">
        <el-descriptions title="基础信息"></el-descriptions>
        <el-form-item label="上级分类" :prop="isParentid?'parentId':''" v-if="form.sourceType!==7">
          <treeselect v-model="form.parentId" :disabled="form.id && !form.parentId" :options="filteredMenuOptions" :normalizer="normalizer" :show-count="true" noOptionsText="暂无数据" placeholder="请选择" />
        </el-form-item>
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入分类名称" />
        </el-form-item>
        <el-form-item label="背景图" prop="bgImage">
          <imageUpload v-model="form.bgImage" width="36" height="36" />
        </el-form-item>
        <el-form-item label="页面排序(从小到大)" prop="orderNo">
          <el-input v-model="form.orderNo" />
        </el-form-item>
        <el-form-item label="描述" prop="description" class="width100">
          <el-input v-model="form.description" placeholder="请输入描述" />
        </el-form-item>
        <el-form-item label="状态" prop="state" class="width100">
          <el-switch v-model="form.state" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-card>
      <el-card class="box-card mt10">
        <el-descriptions title="权限配置"></el-descriptions>
        <el-form-item label="查看权限类型" prop="authType" class="width100">
          <el-select v-model="form.authType" placeholder="请选择" clearable size="small">
            <el-option label="按身份" :value="1"></el-option>
            <el-option label="按指定人" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- 使用 key 确保每次打开弹窗时组件重新创建，强制重新加载数据 -->
        <jurisd :key="`jurisd-${jurisdKey}`" :form="form" title="查看身份权限" v-if="form.authType === 1" />
        <el-form-item label="指定人查看：" class="width100" v-if="form.authType === 2">
          <div style="display: flex;">
            <el-select v-model="form.levelType" placeholder="选择身份" @change="changeLevel" style="width: 200px">
              <!-- 1业务老师2技术老师3内部员工4加盟商5普通用户 -->
              <el-option label="业务老师" :value="1"></el-option>
              <el-option label="技术老师" :value="2"></el-option>
              <el-option label="内部员工" :value="3"></el-option>
              <el-option label="加盟商" :value="4"></el-option>
              <el-option label="普通用户" :value="5"></el-option>
            </el-select>
            <el-select v-model="form.userData" value-key="userId" filterable multiple remote placeholder="请输入手机号/姓名进行搜索" :remote-method="searchUsers" :loading="loading">
              <el-option v-for="item in options" :key="item.userId" :label="item.realName + '('+ item.levelName+')'" :value="item">
              </el-option> 
            </el-select>
          </div>
        </el-form-item>
      </el-card>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import templateClassificationApi from '@/api/marketing/templateClassification'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ImageUpload from "@/components/ImageUpload";
import Jurisd from './jurisd.vue'
import courseSubjectBarrierStudentApi from '@/api/course/courseSubjectBarrierStudent'

// 分类类别 10 = 项目落地。本页专属，不可切换。
// 写入的仍是 template_classification 表，只是 source_type 固定为 10。
const SOURCE_TYPE_PROJECT_LANDING = 10

function initFormBean() {
  const formBean = {
    parentId: null,
    name: null,
    sourceType: SOURCE_TYPE_PROJECT_LANDING,
    categoryLevel: 1,
    bgImage: null,
    orderNo: null,
    description: null,
    state: 1,
    authType: 1,
    levelType: null,
    userData: []
  }
  return formBean
}

export default {
  props: ['menuOptions'],
  components: { ImageUpload, Treeselect, Jurisd },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        sourceType: [{ required: true, message: '请选择分类类别', trigger: 'change' }],
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
        categoryLevel: [{ required: true, message: '请选择分类等级', trigger: 'change' }],
        orderNo: [{ required: true, message: '请选择分类等级', trigger: 'change' }, { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
        authType: [{ required: true, message: '请选择查看权限类型', trigger: 'change' }],
      },
      isParentid: false,
      isRepSub: false,
      // 【项目落地】专属页：分类类别恒为 10，保留单元素数组仅为兼容原有取 label 的逻辑
      sourceTypeOptions: [
        { label: '项目落地', value: SOURCE_TYPE_PROJECT_LANDING }
      ],
      options: [],
      loading: false,
      jurisdKey: 0,  // 用于强制组件重新创建
      localMenuOptions: []  // 本地存储的分类选项数据
    }
  },
  computed: {
    /**
     * 根据当前选择的 sourceType 过滤上级分类选项
     */
    filteredMenuOptions() {
      // 优先使用本地加载的数据
      const sourceData = this.localMenuOptions.length > 0 ? this.localMenuOptions : this.menuOptions
      if (!sourceData || !Array.isArray(sourceData)) {
        return []
      }
      if (!this.form.sourceType) {
        return sourceData
      }
      // 递归过滤函数
      const filterBySourceType = (items) => {
        if (!items || !Array.isArray(items)) {
          return []
        }
        return items
          .filter(item => item.sourceType === this.form.sourceType)
          .map(item => {
            const filtered = { ...item }
            if (item.child && Array.isArray(item.child) && item.child.length > 0) {
              filtered.child = filterBySourceType(item.child)
            }
            return filtered
          })
      }
      return filterBySourceType(sourceData)
    }
  },
  created() {
  },
  methods: {
    /**
     * 加载指定类型的分类数据
     */
    loadMenuOptionsBySourceType(sourceType) {
      if (!sourceType) {
        this.localMenuOptions = []
        return
      }
      // 请求对应类型的分类数据
      templateClassificationApi.fetchTreeList({
        sourceType: sourceType,
        pageNo: 1,
        pageSize: 1000  // 获取足够多的数据
      }).then(data => {
        this.localMenuOptions = data.data.list || []
      }).catch(err => {
        console.error('加载分类数据失败:', err)
        this.localMenuOptions = []
      })
    },
    searchUsers(query) {
      if (query !== '') {
        this.loading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.loading = false;
          courseSubjectBarrierStudentApi.fetchUsers({ keyWords: query, type: this.form.levelType, pageNo: 1, pageSize: 100 }).then(data => {
            this.options = data.data.list;
          })
        }, 500);
      } else {
        this.options = [];
      }
    },
    changeLevel() {
      this.value = ''
      this.options = []
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.child && !node.child.length) {
        delete node.child;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.child
      };
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.isParentid = false
      // 先清空旧的身份权限相关字段，再创建新的 form 对象
      if (this.form && typeof this.form === 'object') {
        // 使用 Vue.delete 确保响应式更新
        if (this.form.hasOwnProperty('authCustLevel')) {
          this.$delete(this.form, 'authCustLevel')
        }
        if (this.form.hasOwnProperty('authTechLevel')) {
          this.$delete(this.form, 'authTechLevel')
        }
        if (this.form.hasOwnProperty('isAuthInsider')) {
          this.$delete(this.form, 'isAuthInsider')
        }
        if (this.form.hasOwnProperty('levelDataList')) {
          this.$delete(this.form, 'levelDataList')
        }
      }
      // 创建新的 form 对象，确保完全清空
      this.form = initFormBean()
      console.log('resetForm 后的 form:', this.form)
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.resetForm()
      this.form.parentId = row.id || null
      if (row.id) this.isParentid = true
      // 如果是新建（没有 row.id），使用列表选中的类型；如果是新建二级分类（有 row.id），使用父分类的类型
      if (row && row.id) {
        // 新建二级分类：使用父分类的 sourceType
        this.form.sourceType = row.sourceType || SOURCE_TYPE_PROJECT_LANDING
      } else {
        // 新建一级分类：使用列表当前选中的类型
        this.form.sourceType = SOURCE_TYPE_PROJECT_LANDING
      }
      // 加载对应类型的分类数据
      this.loadMenuOptionsBySourceType(this.form.sourceType)
      // 增加 key 值，确保组件重新创建并重新加载数据
      this.jurisdKey++
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      // 编辑时保持原有的 sourceType（从 row 中获取）
      // 如果 row 中没有 sourceType，则使用列表选中的类型作为默认值
      if (this.form.sourceType === undefined || this.form.sourceType === null) {
        this.form.sourceType = row.sourceType || SOURCE_TYPE_PROJECT_LANDING
      }
      if (row.id && row.parentId) this.isParentid = true
      if (!row.parentId) this.$set(this.form, 'parentId', null)
      
      // 清空身份权限相关的前端展示字段，让组件重新加载
      // 编辑时会从 levelDataList 恢复选中状态
      if (this.form.hasOwnProperty('authCustLevel')) {
        delete this.form.authCustLevel
      }
      if (this.form.hasOwnProperty('authTechLevel')) {
        delete this.form.authTechLevel
      }
      if (this.form.hasOwnProperty('isAuthInsider')) {
        delete this.form.isAuthInsider
      }
      
      if (row.userDataList && row.authType === 2) {
        // 根据 levelId 和 levelSource 来确定 levelType
        const firstItem = row.userDataList[0]
        let levelType = null
        
        if (firstItem) {
          // 根据 levelSource 和 levelId 映射到 levelType
          // levelSource: 1-业务, 2-技术, 3-内部
          if (firstItem.levelSource === 2) {
            // 技术线 -> 技术老师
            levelType = 2
          } else if (firstItem.levelSource === 3) {
            // 内部员工
            levelType = 3
          } else if (firstItem.levelSource === 1) {
            // 业务线：需要根据 levelId 判断
            const levelId = firstItem.levelId
            // levelId:  8-普通用户 -> levelType: 5 (普通用户)
            if ( levelId === 8) {
              levelType = 5
            }else if(levelId === 6 || levelId === 7 ){
               // levelId: 6-研修班, 7-体验班 -> levelType: 4 (加盟商)
              levelType = 4

            }else {
              // 其他业务线身份 -> levelType: 1 (业务老师)
              // 注意：如果需要区分加盟商，可能需要根据 levelId 的特定值来判断
              levelType = 1
            }
          }
        }
        
        // 如果无法确定，使用原来的逻辑（levelSource）
        if (levelType === null) {
          levelType = firstItem ? firstItem.levelSource : 1
        }
        
        this.$set(this.form, 'levelType', levelType)
        let arr = [], arroption = []
        // :label="item.realName + '('+ item.levelName+')'"
        row.userDataList.forEach(item => {
          arr.push(item.userId)
          arroption.push({ realName: item.realName, levelName: item.userIdentity, levelId: item.levelId, userId: item.userId })
        })
        this.$set(this.form, 'userData', arroption)
        this.options = arroption
      }
      // 增加 key 值，确保组件重新创建并重新加载数据
      this.jurisdKey++
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 获取名称的首字母拼写
     */
    getInitials(name) {
      if (!name || name === '') return ''
      
      let initials = ''
      // 简单的拼音首字母映射表（常用字）
      const pinyinMap = {
        '祛': 'Q', '痘': 'D', '物': 'W', '料': 'L', '级': 'J',
        '黑': 'H', '头': 'T', '分': 'F', '享': 'X', '案': 'A',
        '例': 'L', '展': 'Z', '示': 'S', '业': 'Y', '务': 'W',
        '品': 'P', '宣': 'X', '皮': 'P', '科': 'K', '药': 'Y',
        '普': 'P', '新': 'X', '闻': 'W', '咨': 'Z', '询': 'X',
        '患': 'H', '者': 'Z', '就': 'J', '诊': 'Z', '管': 'G',
        '理': 'L', '项': 'X', '目': 'M', '顾': 'G', '客': 'K'
      }
      
      for (let i = 0; i < name.length; i++) {
        const char = name[i]
        // 如果是中文字符
        if (/[\u4e00-\u9fa5]/.test(char)) {
          // 优先使用映射表
          if (pinyinMap[char]) {
            initials += pinyinMap[char]
          } else {
            // 如果没有映射，使用 Unicode 范围判断（简单处理）
            // 这里可以扩展更多映射，或者使用拼音库
            initials += this.getPinyinInitial(char)
          }
        }
        // 如果是英文字母，取首字母（大写）
        else if (/[a-zA-Z]/.test(char)) {
          // 如果是单词的首字母（前面是空格或开头）
          if (i === 0 || name[i - 1] === ' ' || /[^a-zA-Z]/.test(name[i - 1])) {
            initials += char.toUpperCase()
          }
        }
        // 如果是数字，保留
        else if (/[0-9]/.test(char)) {
          initials += char
        }
      }
      
      return initials || 'CAT'
    },
    /**
     * 获取单个中文字符的拼音首字母（简单版本）
     */
    getPinyinInitial(char) {
      // 使用 Unicode 范围简单判断（不准确，但可以工作）
      // 更准确的方法需要完整的拼音库
      const code = char.charCodeAt(0)
      // 这是一个简化的映射，实际应该使用完整的拼音库
      // 这里返回一个默认值，建议后续使用拼音库
      return 'X' // 默认返回 X，实际应该使用拼音库
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      // 仅在按身份时组装 levelData
      const levelData = []
      if (params.authType === 1) {
        if (Array.isArray(this.form.authCustLevel)) {
          const custIds = this.form.authCustLevel
            .filter(item => item.isActive)
            .map(item => item.key)
          if (custIds.length > 0) {
            levelData.push({ levelSource: 1, levelIds: custIds.join(',') })
          }
        }
        if (Array.isArray(this.form.authTechLevel)) {
          const techIds = this.form.authTechLevel
            .filter(item => item.isActive)
            .map(item => item.key)
          if (techIds.length > 0) {
            levelData.push({ levelSource: 2, levelIds: techIds.join(',') })
          }
        }
        if (this.form.isAuthInsider) {
          // 内部员工开启时，传递一个标识
          levelData.push({ levelSource: 3, levelIds: '0' })
        }
        params.levelData = JSON.stringify(levelData)
        params.userData = ''
      }
      // 指定人查看时，组装 userData 数组
      else if (params.authType === 2) {
        // levelSource: 业务1 技术2 内部3 加盟商与普通用户按1传
        const mapLevelSource = { 1: 1, 2: 2, 3: 3, 4: 1, 5: 1 }
        const levelSource = mapLevelSource[this.form.levelType] || 1
        const userData = []
        if (Array.isArray(this.form.userData)) {
          this.form.userData.forEach(sel => {
            // sel 为完整对象（包含 levelId/levelName/userId/realName）
            if (sel && sel.userId) {
              userData.push({ levelSource, levelId: String(sel.levelId), userId: String(sel.userId) })
            }
          })
        }
        params.levelData = ''
        params.userData = JSON.stringify(userData)
      }
      // 清理前端仅用于展示/选择的字段
      delete params.authCustLevel
      delete params.authTechLevel
      delete params.isAuthInsider
      delete params.levelType
      params.categoryLevel = params.parentId ? 2 : 1
      params.orderNo = +params.orderNo || 0
      params.parentId = params.parentId || 0
      // 处理 code 字段：编辑时不传递 code 字段，新建时如果没有值就生成
      if (this.form.id > 0) {
        // 编辑时删除 code 字段，不传给接口
        delete params.code
      } else {
        // 新建时：如果没有值就生成
        if (!params.code || params.code === '' || params.code === null || params.code === undefined) {
          // 使用分类名称的首字母拼写 + 时间戳 + 随机字符串
          const nameInitials = this.getInitials(params.name || '')
          const timestamp = Date.now()
          const randomStr = Math.random().toString(36).substr(2, 6).toUpperCase()
          params.code = nameInitials + timestamp + randomStr
        }
      }
      return params
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let params = this.calcParams()
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            templateClassificationApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            templateClassificationApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
/* 保证选中态(primary)按钮也为朴素样式 */
::v-deep .el-button--primary.is-plain {
  background-color: #fff !important;
  border-color: #409eff !important;
  color: #409eff !important;
}
::v-deep .el-button--primary.is-plain:focus,
::v-deep .el-button--primary.is-plain:hover {
  background-color: #ecf5ff !important;
  border-color: #409eff !important;
  color: #409eff !important;
}
</style>
